export default __webpack_public_path__ + "static/media/Group 1614.cbbe9ec9.png";